export default "__VITE_ASSET__63f7f818__"